import { useAbTestVariant } from '../abtest/useAbTest'

const useAbTestHotelButtonLabel = abtestId => {
  const abtest = useAbTestVariant(abtestId)
  const testLabel = abtest?.data?.label
  const variantId = abtest?.id
  const testId = abtest ? 'cta_hotel' : undefined
  return {
    variantId,
    testId,
    testLabel
  }
}

export default useAbTestHotelButtonLabel
